import DarkTheme from './DarkTheme';
import LightTheme from './LightTheme';

declare module '@mui/material/styles' {
  interface Palette {
    consentButtonColor: Palette['primary'];
  }

  interface PaletteOptions {
    consentButtonColor?: PaletteOptions['primary'];
  }

  interface PaletteColor {
    background?: string;
  }

  interface SimplePaletteColorOptions {
    background?: string;
  }
}

export default function getTheme(isDarkMode: boolean) {
  return isDarkMode ? DarkTheme : LightTheme;
}
